export const locale = {
  lang: 'it',
  data: {
    INSERT_BID: 'Inserimento offerta',
    INVOICE_AMOUNT: 'Importo fattura',
    INVOICE_DUE_DATE: 'Data scadenza fattura',
    INVOICE_EXPECTED_PAYMENT_DATE: 'Data attesa pagamento',
    SELL_NOW: 'Acconto',
    FUND: 'Fondo',
    WALLET_BALANCE: 'Saldo Wallet',
    VIRTUAL_BALANCE: 'Saldo disponibile',
    COMMITTED_DOWNPAYMENTS: 'Acconti da versare',
    DOWN_PAYMENT_AMOUNT: 'Importo Acconto',
    ALERT_INSUFFICIENT_LIQUIDITY: 'Attenzione! La liquidità sul conto non è sufficiente per pagare l\'acconto. Contattare il team CashMe per ulteriori chiarimenti o effettuare un bonifico per garantire la liquidità sufficiente.',
    BID_INTEREST_RATE: 'Interesse mensile',
    TOS_1: 'Confermo di conoscere e accetto i',
    TOS_1_LINK: '"Termini e Condizioni di Utilizzo della Piattaforma"',
    TOS_2: 'Confermo di conoscere e accetto le seguenti',
    TOS_2_LINK: '"Condizioni della Cessione"',
    TOS_3:
      'Accetto che il pagamento del Credito da parte del Debitore Ceduto verrà effettuato sul conto corrente bancario intestato ' +
      "all'Istituto di Pagamento, il quale provvederà prontamente a trasferire il relativo incasso sul Conto di Pagamento del Cessionario, " +
      'al netto del Saldo dovuto al Cedente.',
    TOS_4:
      "Accetto che CashMe, a seguito dell'incasso di ciascun Credito da parte del l'Istituto di Pagamento, provveda a calcolare " +
      "l'importo del Saldo e che l'Istituto di pagamento stesso provveda ad utilizzare parte dell'incasso per procedere al pagamento " +
      'del Saldo dovuto direttamente a favore del Cedente ad eccezione delle cessioni IAS Compliant.',
    SELLER_BUSINESS_NAME: 'Cedente',
    DEBTOR_BUSINESS_NAME: 'Debitore',
    DEBTOR_RATING: 'Rating debitore',
    MAX_BID_INTEREST_RATE: 'Tasso cessione',
    VIEW_INVOICE: 'Visualizza fattura',
    VIEW_RATING: 'Visualizza rating',
    INVOICE_DETAIL: 'Dettagli fattura',
    INSTALLMENTS_ALERT: 'Questa fattura prevede pagamenti rateali',
    SEND: 'Invia offerta',
    CANCEL: 'Annulla',
    TRANSACTION_PASSWORD: 'Password dispositiva',
    ERROR: {
      REQUIRED: 'Campo obbligatorio',
      HIGH: 'Interesse troppo alto',
      WRONG_TRANSACTION_PASSWORD: 'Password dispositiva errata',
      GENERAL: 'Errore: offerta non inviata. Riprova.',
    },
    IAS_COMPLIANT_INVOICE: 'Cessione IAS Compliant',
  },
};
